import React, { useState } from "react";
import styles from "../css/styles.module.css";
import Header from "../components/header.js";

export default function VerifyEmail(props) {
  const [message, setMessage] = useState(null);

  function handleOnClick() {
    props.user.userData
      .sendEmailVerification()
      .then((user) => {
        setMessage({
          message: "Verification email has been sent",
          error: false,
        });
      })
      .catch((err) => {
        console.log(err);
        setMessage({
          message: "Something went wrong",
          error: true,
        });
      });
  }

  return (
    <div>
      <Header />
      <div className={styles.content}>
        <div className={styles.form}>
          <h1>Email not yet verified</h1>
          <br />
          <p>Please verify your email by clicking the button below</p>
          <br />
          <button onClick={handleOnClick}>Verify Email</button>
          {message != null && 
            <div>
              <p className={message.error ? styles.error : styles.success }>{message.message}</p>
              <br/>
              <p>Please refresh the page once you have verified your email</p>
            </div>
          }
        </div>
      </div>
    </div>
  );
}
